const  collapsibles = document.querySelectorAll(".dd");

collapsibles.forEach( dd => {
    const title = dd?.querySelector('.ddt');
    const content = dd?.querySelectorAll('.dd > *:not(.ddt)');
    console.log(title, content);
    const content_container = document.createElement('div');
    content_container.className =  'page-collapsible-content__inner';
    content.forEach( el => {
        content_container.appendChild(el);
    })

    dd.innerHTML = `
        <button type="button" class="page-accordion">
            <h3 class="ddt">${title.innerText[0].toUpperCase() + title.innerText.slice(1).toLowerCase()}</h3>
            <span role="presentation">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon--wide icon-chevron-down"
                     viewBox="0 0 28 16"><path d="M1.57 1.59l12.76 12.77L27.1 1.59" stroke-width="2" stroke="#000" fill="none"
                     fill-rule="evenodd"></path>
                </svg>
            </span>
        </button>
        <div class="page-collapsible-content">
              
        </div>
    `;

    const collapsible = dd.querySelector('.page-collapsible-content');
    collapsible.appendChild(content_container);
    collapsible.style.maxHeight = `0px`;

    const btn = dd.querySelector('button');
    btn.addEventListener( 'click', () => {
        btn.classList.toggle('open');
        if( btn.classList.contains('open') ) {
            collapsible.style.maxHeight = `${content_container.clientHeight}px`;
        } else {
            collapsible.style.maxHeight = `0px`;
        }

    });

});


